import React from 'react'
import { connect } from 'react-redux'
import {
  TYPE_OF_PAGE_DESTINATION,
  TYPE_OF_PAGE_HOLIDAY,
  TYPE_OF_PAGE_CONTENT_HUB,
} from 'constants/landingPage'

import { getShareModalConfig } from 'lib/customer/getShareModalConfig'

import HeadData from 'components/Common/HeadData'
import HubPageHero from './HubPageHero'
import LandingPageHero from './LandingPageHero'
import HeroProps from './HeroProps'
import config from 'constants/config'
import useShareVariant from 'hooks/useShareVariant'

interface Props extends HeroProps {
  version: 'hub' | 'landing'
  metaData: {
    title: string
    description: string
  }
}

function Hero(props: Props) {
  let utmCampaign = 'webshare'
  if (props.typeOfPage === TYPE_OF_PAGE_DESTINATION) {
    utmCampaign = 'destinationpageshare'
  } else if (props.typeOfPage === TYPE_OF_PAGE_HOLIDAY) {
    utmCampaign = 'holidaypageshare'
  } else if (props.typeOfPage === TYPE_OF_PAGE_CONTENT_HUB) {
    utmCampaign = 'hubshare'
  }

  const shareVariant = useShareVariant()

  const shareConfig = getShareModalConfig({
    utmCampaign,
    pathname: props.pathname,
    customerPortalURL: props.customerPortalURL,
    memberId: props.memberId,
    image: {
      id: props.image,
    },
    offerLocation: props.title,
    offerId: '',
    region: props.regionCode,
    type: props.typeOfPage,
    shareVariant,
  }, {
    mailToSubject: encodeURIComponent(`Take a look at these Luxury Escapes deals in ${props.title}`),
    shareMessage: `Check out this amazing ${props.typeOfPage}...`,
  })

  const Component = props.version === 'hub' ? HubPageHero : LandingPageHero
  const headTitle = !!props.title && props.title.trim().length > 0 ? `${props.title} - ${props.metaData.title}` : props.metaData.title

  return <>
    <HeadData
      title={headTitle}
      description={props.metaData.description}
      imageId={props.image}
    />
    <Component
      title={props.title}
      subTitle={props.subTitle}
      headTitle={props.headTitle}
      image={props.image}
      typeOfPage={props.typeOfPage}
      brand={props.brand}
      pathname={props.pathname}
      customerPortalURL={props.customerPortalURL}
      regionCode={props.regionCode}
      showAccountModal={props.showAccountModal}
      hideSignUpOverlay={props.hideSignUpOverlay}
      memberId={props.memberId}
      back={props.back}
      shareConfig={shareConfig}
      linkText={props.linkText}
    />
  </>
}

const mapStateToProps = (state: App.State) => ({
  brand: config.BRAND,
  memberId: state.auth.account.memberId,
  customerPortalURL: state.system.customerPortalURL,
  pathname: state.router.location.pathname,
  regionCode: state.geo.currentRegionCode,
  showAccountModal: state.ui.modal.modalType === 'accountAccess',
})

export default connect(mapStateToProps)(Hero)
